module.exports = __webpack_public_path__ + "img/MM2_150_thumb.4c35d1f8.jpg";